import { Injector } from '@angular/core';
import { NotificationService } from '../../../services/notification-service/notification-service.service';

import { UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { take } from 'rxjs';
import { CtaButtonSignalService } from '../../../services/cta-button-signal-service/cta-button-signal.service';

export function markAllNotificationsAsRead(injector: Injector, attri: UiZoneWidgetAttributeConfig) {
  const notificationService = injector.get(NotificationService);
  const ctaButtonSignalService = injector.get(CtaButtonSignalService);
  const key = attri.widgetProperties?.['buttonActionType'] as string;
  ctaButtonSignalService.setButtonLoadingSignal({
    [key]: true,
  });
  notificationService
    .markAllNotificationsAsRead()
    .pipe(take(1))
    .subscribe(() => {
      ctaButtonSignalService.setButtonLoadingSignal({
        [key]: false,
      });
    });
}
